import { render, staticRenderFns } from "./EstadisticasIntakes.vue?vue&type=template&id=3b1ab4e3"
import script from "./EstadisticasIntakes.vue?vue&type=script&lang=js"
export * from "./EstadisticasIntakes.vue?vue&type=script&lang=js"
import style0 from "../../components/Estadisticas/estadisticas.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EstadisticasIntakes.vue?vue&type=style&index=1&id=3b1ab4e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports